
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { useTheme } from "@/lib/theme/ThemeContext";
import { useAddChildForm } from "@/components/children/hooks/useAddChildForm";
import { AddChildForm } from "@/components/children/AddChildForm";
import { AddChildDialogHeader } from "@/components/children/AddChildDialogHeader";
import { AddChildDialogFooter } from "@/components/children/AddChildDialogFooter";

export interface AddChildDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (childId: string) => void;
}

export function AddChildDialog({ open, onOpenChange, onSuccess }: AddChildDialogProps) {
  const isLightTheme = false;
  
  const {
    name,
    setName,
    dateOfBirth,
    setDateOfBirth,
    isSubmitting,
    handleSubmit,
    resetForm
  } = useAddChildForm(onSuccess);

  const handleClose = () => {
    onOpenChange(false);
    resetForm();
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className={`sm:max-w-[425px] ${
        isLightTheme 
          ? "bg-white border-slate-200 shadow-lg" 
          : "bg-[#1E293B] border-gray-700 text-gray-100"
      }`}>
        <DialogHeader>
          <AddChildDialogHeader />
        </DialogHeader>

        <AddChildForm
          name={name}
          setName={setName}
          dateOfBirth={dateOfBirth}
          setDateOfBirth={setDateOfBirth}
        />

        <AddChildDialogFooter
          onCancel={handleClose}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          isDisabled={!name || !dateOfBirth}
        />
      </DialogContent>
    </Dialog>
  );
}
